import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BucketFiltersState {
    search: string;
    project_state: string;
    from: string | null;
    to: string | null;
}

const initialState: BucketFiltersState = {
    search: "",
    project_state: "",
    from: null,
    to: null,
};

const bucketFiltersSlice = createSlice({
    name: "bucketFilters",
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<Partial<BucketFiltersState>>) => {
            return { ...state, ...action.payload };
        },
        clearFilters: () => initialState,
    },
});

export const { setFilters, clearFilters } = bucketFiltersSlice.actions;
export default bucketFiltersSlice.reducer;